import { List } from 'immutable';
import { secondaryDealConstants } from '../constants';

export function secondary_deals(state = {}, action) {
  switch (action.type) {
    case secondaryDealConstants.SECONDARY_DEAL_LIST_LOADING:
      return {
        ...state,
        listLoading: true
      };
    case secondaryDealConstants.SECONDARY_DEAL_LIST_SUCCESS:
      return {
        ...state,
        items: List(action.response),
        listLoading: false
      };
    case secondaryDealConstants.SECONDARY_DEAL_LIST_FAILURE:
      return {
        ...state,
        listLoading: false,
        items: [],
        listError: action.error
      };
    case secondaryDealConstants.SECONDARY_DEAL_CREATE_LOADING:
      return {
        ...state,
        createLoading: true
      };
    case secondaryDealConstants.SECONDARY_DEAL_CREATE_SUCCESS: {
      const items = state.items ? state.items : List();
      return {
        ...state,
        items: items.push(action.response),
        createLoading: false,
        createError: null
      };
    }
    case secondaryDealConstants.SECONDARY_DEAL_CREATE_FAILURE:
      return {
        ...state,
        createLoading: false,
        createError: action.error
      };

    case secondaryDealConstants.SECONDARY_DEAL_EDIT_LOADING:
      return {
        ...state,
        editLoading: true
      };
    case secondaryDealConstants.SECONDARY_DEAL_EDIT_SUCCESS: {
      if (!state.items) {
        return state;
      }

      const secondaryDealIndex = state.items.findIndex(val => val.id == action.response.id);

      if (secondaryDealIndex == -1) {
        return state;
      }

      return {
        ...state,
        items: state.items.set(secondaryDealIndex, action.response),
        editLoading: false,
        editError: null
      };
    }
    case secondaryDealConstants.SECONDARY_DEAL_EDIT_FAILURE:
      return {
        ...state,
        editLoading: false,
        editError: action.error
      };

    case secondaryDealConstants.SECONDARY_DEAL_DELETE_LOADING:
      return {
        ...state,
        deleteLoading: true
      };
    case secondaryDealConstants.SECONDARY_DEAL_DELETE_SUCCESS: {
      const { secondaryDealId } = action;

      if (!state.items) {
        return state;
      }

      const secondaryDealIndex = state.items.findIndex(val => val.id == secondaryDealId);

      if (secondaryDealIndex == -1) {
        return state;
      }

      return {
        ...state,
        items: state.items.delete(secondaryDealIndex),
        deleteLoading: false,
        deleteError: null
      };
    }
    case secondaryDealConstants.SECONDARY_DEAL_DELETE_FAILURE:
      return {
        ...state,
        deleteLoading: false,
        deleteError: action.error
      };
    case secondaryDealConstants.SECONDARY_DEAL_ERROR_RELOAD:
      return {
        ...state,
        createError: null,
        editError: null
      };

    default:
      return state;
  }
}
